// @flow
import EventsList from './EventsList';

export default EventsList;
